export enum ComponentsEnum {
  Views = "bst_insights_views",
  Filters = "bst_insights_filters",
  Sorts = "bst_insights_sorts",
  UserManagementGridSorts = "bst_insights_user_management_grid_sorts",
  UserManagementGridSizes = "bst_insights_user_management_grid_sizes",
  UserManagementGridFilters = "bst_insights_user_management_grid_filters",
  UserManagementGrid = "bst_insights_user_management_grid",
  NLMProjectOverrideGrid = "bst_insights_nlm_project_override_grid",
  FilterPaneSettings = "bst_insights_filter_pane",
}
